import { render, staticRenderFns } from "./pstjList.vue?vue&type=template&id=e8caa5f8&scoped=true&"
import script from "./pstjList.vue?vue&type=script&lang=js&"
export * from "./pstjList.vue?vue&type=script&lang=js&"
import style0 from "./pstjList.vue?vue&type=style&index=0&id=e8caa5f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8caa5f8",
  null
  
)

export default component.exports